:host {
  display: block;
  width: 100%;
  position: relative;
}

.sportsline-pick-snippet--loading {
  display: grid;
  place-items: center;
}
